



























import { Component, Prop, Mixins, Watch } from 'vue-property-decorator'
import BaseVue from '@/mixins/BaseVue'
import VAutocompleteWithValidation from '@/components/Inputs/VAutocompleteWithValidation.vue'
import { Customer, EPromotionStatus, ECustomerGroup } from '@/services/connecteur'
import customerModule from '@/store/modules/CustomerModule'
import codeFormat from '@/filters/cmmfCodeFormat'
import VueI18n from 'vue-i18n'

@Component({
  components: {
    VAutocompleteWithValidation
  },
  filters: {
    codeFormat
  }
})
export default class CustomerSelect extends Mixins(BaseVue) {
  @Prop({ default: 0 })
  public id!: number

  @Prop({ default: 0, required: true })
  public salesOrgId!: number

  @Prop({ default: 0, required: true })
  public statusId!: EPromotionStatus

  public searchValue = ''
  public customerList: Customer[] = new Array<Customer>()

  // #region Getter

  public get isNotNewOrRework () {
    return !(
      this.statusId === EPromotionStatus.NEW ||
      this.statusId === EPromotionStatus.REWORK
    )
  }

  public get customerSearch () {
    if (this.searchValue) {
      const search = this.searchValue.toUpperCase()
      return this.customerList.filter(
        customer =>
          customer?.name?.toUpperCase().includes(search) ||
          (customer?.code !== undefined &&
            codeFormat(customer.code, true)
              .includes(search))
      )
    }

    return this.customerList
  }

  public get customerMla () {
    if (this.id) {
      const customers = this.customerList.filter(c => c.id === this.id)
      return customers.length && customers[0].mla
        ? this.$t('customer.provided_mla', { mla: customers[0].mla })
        : undefined
    }
    return undefined
  }

  // #endregion

  // #region public method

  public updateId (newValue: number) {
    this.$emit('update:id', newValue)
  }

  public getLvlName (group: ECustomerGroup): string {
    let result: VueI18n.TranslateResult = this.$t('customer.unknown')
    switch (group) {
      case ECustomerGroup.LOCAL_HIERARCHY_NODE:
        result = this.$t('customer.central')
        break
      case ECustomerGroup.LOCAL_CUSTOMER_SOLD_TO_PARTY:
        result = this.$t('customer.regional')
        break
      case ECustomerGroup.SOLD_TO_PARTY_COMMON:
        result = this.$t('customer.soldto')
        break
      case ECustomerGroup.SOLD_TO_PARTY_LOCAL:
        result = this.$t('customer.soldto')
        break
    }

    return result.toString()
  }

  // #endregion

  // #region  Watcher

  @Watch('salesOrgId', { immediate: true })
  public async updateCustomerList () {
      try {
        if (this.salesOrgId) {
          this.customerList = await customerModule.getCustomers(
            this.salesOrgId
          )
        }
      } catch (error) {
        this.displayError(error)
      }
    }

    // #endregion
  }
